import translate from './services/translationService';
const isLocal = (() => {
    const script = document.querySelector('#smartagent');
    return script.classList.contains('local');
})();
export const getEnv = () => {
    if (isLocal)
        return 'dev';
    const script = document.querySelector('#smartagent');
    for (const env of ['dev', 'uat']) {
        if (script.src.includes(env)) {
            return env;
        }
    }
    return 'prod';
};
export const getLoaderScriptAttributes = () => {
    const script = document.querySelector('#smartagent');
    const company = script.getAttribute('company') ??
        script.getAttribute('data-company');
    const facia = script.getAttribute('facia') ??
        script.getAttribute('data-facia') ??
        company;
    const language = script.getAttribute('language') ??
        script.getAttribute('data-language') ??
        getLanguage();
    const region = script.getAttribute('region') ?? undefined;
    return { company, facia, language, region };
};
export const getChatServiceURL = () => {
    const env = getEnv();
    const { region } = getLoaderScriptAttributes();
    if (!region || region === 'eu-west-2') {
        return {
            dev: 'https://dev-services.smartagent.app/chat-service',
            uat: 'https://uat-services.smartagent.app/chat-service',
            prod: 'https://services.smartagent.app/chat-service',
        }[env];
    }
    else {
        return {
            dev: `https://${region}.dev-services.smartagent.app/chat-service`,
            uat: `https://${region}.uat-services.smartagent.app/chat-service`,
            prod: `https://${region}.services.smartagent.app/chat-service`,
        }[env];
    }
};
export const getChatStaticURL = () => {
    const env = getEnv();
    // These will be replaced at build time by Rollup
    const envUrls = {
        "dev": process.env.CHAT_URL_DEV || "https://dev-chat.smartagent.app",
        "uat": process.env.CHAT_URL_UAT || "https://uat-chat.smartagent.app",
        "prod": process.env.CHAT_URL_PROD || "https://chat.smartagent.app",
    };
    const base = envUrls[env];
    //    return `${base}/static/js/bundle.js`;
    return `${base}/static`;
};
export const getChatAppURL = () => `${getChatStaticURL()}/bundle.js`;
export const getChatStylesURL = () => `${getChatStaticURL()}/bundle.css`;
const getLanguage = () => {
    const { lang = 'en' } = document.documentElement;
    const [language] = lang.split('-');
    return language;
};
const showChatWrapper = () => {
    getWrapper().style.display = 'block';
};
export const getNonce = () => {
    const mainJSImport = document.getElementById('smartagent');
    return mainJSImport.nonce || mainJSImport.getAttribute('nonce') || null;
};
export const loadCSS = async () => {
    const { company, facia } = getLoaderScriptAttributes();
    const url = `${getScriptBaseUrl()}/css/${company}/${facia}/loader.css`;
    const link = document.createElement('link');
    link.href = url;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.onload = showChatWrapper;
    link.onerror = showChatWrapper;
    // Add nonce to CSS import
    link.setAttribute('nonce', getNonce());
    document.head.appendChild(link);
    // Load CSS from Chat App
    const linkStylesChat = document.createElement('link');
    linkStylesChat.href = getChatStylesURL();
    linkStylesChat.type = 'text/css';
    linkStylesChat.rel = 'stylesheet';
    linkStylesChat.setAttribute('nonce', getNonce());
    document.head.appendChild(linkStylesChat);
};
export const loadChatApp = (config) => {
    const script = document.createElement('script');
    script.setAttribute('id', 'smartagent-script-chat-app');
    script.setAttribute('src', getChatAppURL());
    script.setAttribute('type', 'module');
    script.setAttribute('async', 'false');
    script.setAttribute('companyID', config.appConfig.companyID);
    script.setAttribute('chatFlowId', config.chatFlowId);
    script.setAttribute('facia', config.appConfig.facia);
    script.setAttribute('language', config.language);
    script.setAttribute('nonce', getNonce());
    document.body.append(script);
};
export const loadFonts = async () => {
    const fontsFamilies = ['Rubik', 'Roboto'];
    fontsFamilies.forEach((fontFamily) => {
        const fontLink = document.createElement('link');
        fontLink.setAttribute('href', `https://fonts.googleapis.com/css?family=${fontFamily}:300,400,500,700`);
        fontLink.setAttribute('rel', 'stylesheet');
        fontLink.setAttribute('nonce', getNonce());
        document.head.append(fontLink);
    });
};
const getScriptBaseUrl = () => {
    const script = document.querySelector('#smartagent');
    if (script.classList.contains('local')) {
        return 'https://dev-chat-loader.smartagent.app';
    }
    return script.src.split('/').slice(0, -2).join('/');
};
export const getWrapper = () => {
    return document.querySelector('.sa-chat-wrapper');
};
export const getTab = () => {
    return document.querySelector('.sa-chat-tab');
};
export const getSlideout = () => {
    return document.querySelector('.sa-chat-slideout');
};
export const getNavMenu = () => {
    return document.querySelector('.sa-chat-header-nav-menu');
};
export const getAudioAlertsWrapper = () => document.querySelector('.sa-chat-header-audio-alert-wrapper');
export const notificationCounter = (language) => {
    const notificationCounter = document.querySelector('.sa-message-count');
    const textCounter = document.querySelector('.sa-message-announce');
    const messageCount = notificationCounter.innerHTML;
    const increase = () => {
        const currentCount = Number(messageCount);
        const nextCount = currentCount + 1;
        notificationCounter.innerHTML = nextCount.toString();
        if (currentCount === 0)
            notificationCounter.style.display = 'flex';
        textCounter.innerHTML = `${nextCount} ${nextCount === 1
            ? `${translate('new chat message', language)}`
            : `${translate('new chat messages', language)}`}`;
    };
    const reset = () => {
        notificationCounter.style.display = 'none';
        notificationCounter.innerHTML = '0';
        textCounter.innerHTML = '';
    };
    return {
        increase,
        reset
    };
};
export const getTitleNotificationManager = () => {
    const { language } = getLoaderScriptAttributes();
    const testRegex = new RegExp(`\\[(\\d+)\\] ${translate('New Messages', language)}? \\| `);
    let newMessages = 0;
    let enabled = false;
    let initialised = false;
    const newMessage = () => {
        if (!enabled || !document.hidden)
            return;
        newMessages += 1;
        let clearTitle = document.title.replace(testRegex, "");
        const newMessagesText = newMessages > 1
            ? translate('New Messages', language)
            : translate('New Message', language);
        document.title = `[${newMessages}] ${newMessagesText} | ${clearTitle}`;
    };
    const clear = () => {
        if (!enabled)
            return;
        newMessages = 0;
        console.log('resetting title notifications', document.title);
        document.title = document.title.replace(testRegex, "");
    };
    const setup = (enableTitleNotifications) => {
        if (initialised)
            return;
        enabled = enableTitleNotifications;
        initialised = true;
        if (enabled) {
            console.log('title notifications enabled, setting event listener');
            window.addEventListener('focus', clear);
        }
    };
    return {
        newMessage,
        clear,
        setup
    };
};
export const turnOffThenSetAriaLiveValue = (elementId, timeout = 200) => {
    const element = document.querySelector(elementId);
    const ariaLiveValue = element?.getAttribute('aria-live');
    if (ariaLiveValue) {
        element?.setAttribute('aria-live', 'off');
        setTimeout(() => element?.setAttribute('aria-live', ariaLiveValue), timeout);
    }
};
